module.exports = __webpack_public_path__ + "img/z3.png";